import React from 'react'
import ListItemButton from '@mui/material/ListItemButton'
import { SideMenuItemComponentProps } from './types'
import { createStyles, makeStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'
import { COLOR_MENU_PRIMARY } from '../../routes/color-constants'
import { Paper } from '@mui/material'
import { NavLink } from 'react-router-dom'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    active: {
      color: "white",
    },
    inactive: {
      color: COLOR_MENU_PRIMARY,
    },
  })
)

const SideBarMenuItemComponent: React.FC<SideMenuItemComponentProps> = (props) => {
  const { className, onClick, path, children, color } = props
  const classes = useStyles()

  return (
    <>
      {!path ? (
        <ListItemButton
          className={className + ' ' + classes.inactive}
          onClick={onClick}
        >
          {children}
        </ListItemButton>
      ) : (
        <NavLink
          to={path}
          className={({ isActive }) => className + ' ' + (isActive ? classes.active : classes.inactive)}
        >
          <ListItemButton className={className} onClick={onClick}>
            {children}
          </ListItemButton>
        </NavLink>
      )}
    </>
  )
}

export default SideBarMenuItemComponent
